var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("CMS")]),_c('div',{staticClass:"tips"},[_vm._v("欢迎使用CMS")])])
}]

export { render, staticRenderFns }